import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { measurePageLoad, preloadCriticalResources } from "./utils/performance";
import { initializeErrorHandling } from "./utils/errorHandling";
import { initializeAccessibility } from "./utils/accessibility";

// Initialize global error handling
initializeErrorHandling();

// Initialize performance monitoring
measurePageLoad();
// initializePerformanceMonitoring(); // Disabled - performance warnings not needed

// Initialize accessibility features
initializeAccessibility();

// Preload critical resources
preloadCriticalResources([
  "/src/assets/logos/right_logo_tag.png", // Navigation logo
  "/src/assets/images/graeme_headshot.jpg", // Profile image
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
